var Typeahead, ax, base, base1, getAutocompleteList, getRecentSearches, moveAutocomplete, ref, removeRecentSearch, removeRecentSearches, setRecentSearches,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ref = require('../helper/m_typeahead_helper'), getAutocompleteList = ref.getAutocompleteList, getRecentSearches = ref.getRecentSearches, moveAutocomplete = ref.moveAutocomplete, removeRecentSearch = ref.removeRecentSearch, removeRecentSearches = ref.removeRecentSearches, setRecentSearches = ref.setRecentSearches;

ax = require('../helper/m_common').ax;

module.exports = Typeahead = (function() {
  function Typeahead(opts) {
    this.buildAutocompleteList = bind(this.buildAutocompleteList, this);
    this.removeTabIndex = bind(this.removeTabIndex, this);
    this.rerender = bind(this.rerender, this);
    this.success = bind(this.success, this);
    var ref1, ref2, ref3;
    this.env = opts.env, this.hasBetterUx = opts.enableBetterUx, this.hasGeolocation = opts.enableGeolocation, this.hasSearchCategories = opts.enableSearchCategories, this.endpoints = opts.endpoints, this.experiments = opts.experiments, this.$container = opts.resultList;
    this.query = '';
    this.ctx = 'search';
    this.$form = $('#search-bar, #ls-search-form');
    this.$inputs = this.$form.find('input');
    this.$search = this.$form.find('#search, #ls-search');
    this.$location = this.$form.find('#location, #ls-location');
    this.lat = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.lat : void 0 : void 0;
    this.lng = typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.division) != null ? ref2.lng : void 0 : void 0;
    this.locale = document.head.getAttribute('data-locale');
    this.consumer_id = Cookie.get('snickerdoodle');
    this.result = [];
    this.hasRecentSearches = false;
    this.hasRecentLocations = false;
    if (opts.enableRecentSearches) {
      this.getRecentSearches();
    }
    if (opts.enableRecentLocations) {
      this.getRecentLocations();
    }
    if ((ref3 = Groupon.LS) != null ? ref3.hasTouch : void 0) {
      this.setBHViewport();
    }
    this.bind();
  }

  Typeahead.prototype.bind = function() {
    this.$container.on('click', '.tw-item .tw-clear', (function(_this) {
      return function(e) {
        var $item, ctx, value;
        e.preventDefault();
        e.stopImmediatePropagation();
        $item = $(e.currentTarget).siblings('.tw-link');
        if (!(value = $item.attr('data-value'))) {
          return;
        }
        ctx = _this.ctx;
        removeRecentSearch(value, ctx);
        _this.rerender(e, ctx);
      };
    })(this));
    this.$container.on('click', '.tw-heading .tw-clear', (function(_this) {
      return function(e) {
        var ctx;
        ctx = _this.ctx;
        removeRecentSearches(ctx);
        _this.rerender(e, ctx);
      };
    })(this));
  };


  /*
   * Fetch relevance API (deal / location)
   *
   * @param {String} query - Term to search
   */

  Typeahead.prototype.fetch = function(query) {
    var ell, lat, lng, ref1, ref2;
    if ($('.ls-error-dialog').length) {
      return;
    }
    if (query === this.query && ((ref1 = this.result) != null ? ref1.length : void 0)) {
      this.buildView(_.deepClone(this.result), query);
      return;
    }
    if (this.env === 'desktop') {
      if (Groupon.LS.experiments['LS-2426-use-ell-for-relevance'] && ((ell = Cookie.get('ell')) != null)) {
        ref2 = ell.split(','), lat = ref2[0], lng = ref2[1];
      } else {
        lat = this.lat;
        lng = this.lng;
      }
    }
    this.query = query;
    return $.ajax({
      url: this.endpoints[this.ctx],
      contentType: "application/json; charset=utf-8",
      dataType: "jsonp",
      type: 'get',
      data: {
        query: this.query,
        limit: 10,
        lat: this.lat,
        lng: this.lng,
        locale: this.locale,
        consumer_id: this.consumer_id
      },
      cache: false,
      success: this.success,
      error: (function(_this) {
        return function() {
          return _this.reset();
        };
      })(this)
    });
  };


  /*
   * Success handler for relevance API call.
   * Selects and updates response.
   *
   * @param {Object} res - Object containing API response for either deal or location
   */

  Typeahead.prototype.success = function(res) {
    var deals, locations, result;
    if ($('.ls-error-dialog').length) {
      return;
    }
    locations = res.locationsAutocompleteResults, deals = res.dealsAutocompleteResults;
    result = [];
    if (deals != null ? deals.length : void 0) {
      result = [
        {
          collection: deals,
          widget: 'autocomplete'
        }
      ];
    } else if (locations != null ? locations.length : void 0) {
      result = [
        {
          collection: locations,
          widget: 'autocomplete'
        }
      ];
    }
    if (this.hasGeolocation && locations) {
      result.unshift({
        collection: [],
        widget: 'geolocation'
      });
    }
    if (result.length) {
      this.result = _.deepClone(result);
    }
    this.buildView(this.result, this.query);
  };


  /*
   * Generate typeahead html and append to typeahead container
   *
   * @param {Array}  collections - Updated
   * @param {String} query
   */

  Typeahead.prototype.buildView = function(collections, query) {
    var $container, bh, bhw, index, list, prefix, ref1;
    this.reset();
    if (!collections.length) {
      return;
    }
    $container = this.$container;
    ref1 = getAutocompleteList(collections, query, {
      experiments: this.experiments
    }), list = ref1.list, index = ref1.index, bh = ref1.bh, prefix = ref1.prefix;
    if (list != null ? list.length : void 0) {
      list.unshift("<ul role='list' data-" + bh.type + "='" + bh.val + "'>");
      list.push('</ul>');
      switch (this.ctx) {
        case 'search':
          bhw = 'DealSearchBarAutoComplete';
          if (prefix) {
            this.$search.attr('aria-activedescendant', prefix + '0');
          }
          break;
        case 'location':
          bhw = 'LocationSearchBarAutoComplete';
          if (prefix) {
            this.$location.attr('aria-activedescendant', prefix + '0');
          }
      }
      $container.removeClass('typeahead-search typeahead-location').addClass('typeahead-' + this.ctx).html(list.join('')).attr('data-bhw', bhw).show();
      ax.show($container, this.removeTabIndex);
      if (this.env === 'desktop' && index > -1) {
        this.highlightMatch($container);
      }
    } else {
      ax.hide($container);
      $container.hide();
    }
  };

  Typeahead.prototype.rerender = function(e, ctx) {
    switch (ctx) {
      case 'search':
        this.getRecentSearches();
        break;
      case 'location':
        this.getRecentLocations();
    }
    if (e != null) {
      e.currentTarget.id = ctx;
    }
    this.buildAutocompleteList(e, ctx);
  };

  Typeahead.prototype.removeTabIndex = function() {
    return this.$container.removeAttr('tabindex');
  };


  /*
   * Clear typeahead list
   */

  Typeahead.prototype.reset = function() {
    this.$container.find('ul').empty();
    ax.hide(this.containers);
    this.$inputs.removeAttr('aria-activedescendant');
  };

  Typeahead.prototype.hide = function() {
    this.reset();
    return this.$container.hide().attr('aria-hidden', 'true').empty();
  };


  /*
   * Method triggered by deal / location input events to decide
   * the type of typeahead and emit relevance ajax request
   *
   * @param {Object} e   - jQuery event
   * @param {String} ctx - Context: 'search' or 'location' input
   */

  Typeahead.prototype.buildAutocompleteList = function(e, ctx) {
    var id, query, ref1;
    if (e != null) {
      e.preventDefault();
    }
    this.ctx = ctx;
    ref1 = e.currentTarget, id = ref1.id, query = ref1.value;
    moveAutocomplete(this.$container, ctx, this.env);
    if (e.type === 'focusin' && id === 'ls-location') {
      query = '';
    } else {
      query = (query != null ? query.trim() : void 0) || '';
    }
    if (!query) {
      this.reset();
      switch (id) {
        case 'search':
        case 'ls-search':
          this.showDealWidget();
          break;
        case 'location':
        case 'ls-location':
          this.showLocationWidget();
      }
    } else {
      this.fetch(query);
    }
  };

  Typeahead.prototype.getRecentSearches = function() {
    var ref1;
    this.recentKeywords = getRecentSearches('deal');
    return this.hasRecentSearches = ((ref1 = this.recentKeywords) != null ? ref1.length : void 0) > 0;
  };

  Typeahead.prototype.getRecentLocations = function() {
    var locations, ref1;
    locations = getRecentSearches('location');
    this.recentLocations = locations.filter(function(e) {
      return e.hasOwnProperty('division');
    });
    if (((ref1 = this.recentLocations) != null ? ref1.length : void 0) > 0) {
      if (this.recentLocations.length !== locations.length) {
        setRecentSearches(this.recentLocations, 'location');
      }
      if (typeof this.recentLocations[0] === 'object') {
        return this.hasRecentLocations = true;
      } else {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem('LS_recentLocations') : void 0;
      }
    }
  };

  Typeahead.prototype.highlightMatch = function($list) {
    var $matchedItem;
    $matchedItem = $list.find('.typeahead-match');
    return $list.on({
      mouseenter: function() {
        document.activeElement.blur();
        return $matchedItem.removeClass('typeahead-match-highlight');
      },
      mouseleave: function() {
        return $matchedItem.addClass('typeahead-match-highlight');
      }
    });
  };


  /*
   * Build configurable collections for deal typeahead when input is empty
   */

  Typeahead.prototype.showDealWidget = function() {
    var collections, hasRecentSearches, hasSearchCategories, keywords, ref1, ref2, ref3;
    hasRecentSearches = this.hasRecentSearches;
    hasSearchCategories = this.hasSearchCategories;
    if (!this.searchCategories) {
      this.searchCategories = ((ref1 = Groupon.LS.data) != null ? ref1.searchCategories : void 0) || [];
      this.hasSearchCategories = hasSearchCategories = ((ref2 = this.searchCategories) != null ? ref2.length : void 0) > 0;
    }
    if (hasRecentSearches || hasSearchCategories) {
      collections = [];
      if (hasRecentSearches) {
        keywords = (ref3 = this.recentKeywords) != null ? ref3.slice(0) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentSearches'
          }
        ]);
      }
      if (hasSearchCategories) {
        collections.push.apply(collections, [
          {
            collection: this.searchCategories.slice(0),
            widget: 'searchCategories'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Build configurable collections for location typeahead when input is empty
   */

  Typeahead.prototype.showLocationWidget = function() {
    var collections, hasBetterUx, hasGeolocation, hasRecentLocations, keywords, ref1;
    hasGeolocation = this.hasGeolocation;
    hasRecentLocations = this.hasRecentLocations;
    hasBetterUx = this.hasBetterUx;
    if (hasGeolocation || hasRecentLocations || hasBetterUx) {
      collections = [];
      if (hasGeolocation) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'geolocation'
          }
        ]);
      }
      if (hasBetterUx) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'helperMessage'
          }
        ]);
      }
      if (hasRecentLocations) {
        keywords = (ref1 = this.recentLocations) != null ? ref1.slice(0, 5) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentLocations'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Prevent bloodhound impression tracking on typeahead due to performance reasons
   */

  Typeahead.prototype.setBHViewport = function(state) {
    if (state == null) {
      state = 'ignore';
    }
    this.$container.attr('data-bh-viewport', state);
  };

  return Typeahead;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).View == null) {
  base1.View = {};
}

_.extend(window.Groupon.Modules.SearchBar.View, {
  Typeahead: Typeahead
});

//# sourceMappingURL=data:application/json;base64,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
